var render = function render(){var _vm=this,_c=_vm._self._c;return _c('asd20-school-directory',{attrs:{"initial-view":_vm.initialView,"initial-boundary-visible":_vm.initialBoundaryVisible}})
}
var staticRenderFns = []

export { render, staticRenderFns }